import { Button } from '../../Common';

interface Props {
    img: string;
    title: string;
    paragraph?: string;
    buttonText?: string;
    onClick?: () => void;
}

export default function EmptyScreen({ img, title, paragraph, buttonText, onClick }: Props) {
    return (
        <div className="empty-screen__wrapper">
            <div className="empty-screen">
                <img src={img} alt="empty-screen" />
                <div className="empty-screen__content">
                    <h1 className="empty-screen__content--title">{title}</h1>
                    {paragraph && <p className="empty-screen__content--paragraph">{paragraph}</p>}
                </div>
                {buttonText && <Button onClick={onClick} text={buttonText} />}
            </div>
        </div>
    );
}
